var adsBannerOrientationData = ['landscape', 'portrait'];
export default adsBannerOrientationData;